import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminDataService {
 
  constructor(private http: HttpClient) { }

  public apiUrl = `${environment.apiUrl}/Dashboard`;

  getAdminDashboard(): Observable<any> {
    return this.http.get(`${this.apiUrl}/GetAdminDashboard`)
  }
  
  getAdminDashboardLastTen(): Observable<any> {
    return this.http.get(`${this.apiUrl}/GetDashboardGraphics`)
  }
}
